import { useQuery } from 'react-query'
import { useChosenCompany, useUser } from '../../../../context/UserProvider'
import { fetchFuelAccountExpensesReport } from '../../../../api/newApi'
import { useParams, useSearchParams } from 'react-router-dom'
import FuelReportExpenseDetailsTable from '../components/FuelTables/FuelReportExpenseDetailsTable'
import { ExcelExportButton } from '../components/ExcelExporter'
import { excelFuelReportExpenseDetailsColumns } from '../components/FuelTables/excelUtils'
import type { FuelReportExpenseDetails as FuelReportExpenseDetailsItem } from '../../../../types'
import { mapMonth } from '../utils/mapMonth'

const FuelReportExpenseDetails = () => {
  const { date, account } = useParams()
  const [searchParams] = useSearchParams()
  const regNo = searchParams.get('regNo') || ''
  const consolidatedAgreementID = searchParams.get('consolidatedAgreementID') || undefined
  const company = useChosenCompany()
  const companyId = company?.id
  const contactId = useUser()?.user?.id

  const [year, month] = date ? date.split('-') : ['', '']

  const { data: response, isLoading } = useQuery(
    ['fuelReportExpenseDetails', companyId, contactId, year, month, account, consolidatedAgreementID],
    () =>
      fetchFuelAccountExpensesReport({
        companyId: companyId || '',
        contactId: contactId || '',
        consolidatedAgreementID,
        accountNo: account || '',
        year,
        month,
      }),
    { enabled: !!companyId && !!contactId && !!account && !!year && !!month },
  )

  const responseItems = (response as any)?.items
  const data = (Array.isArray(responseItems) ? responseItems : []) as FuelReportExpenseDetailsItem[]

  const columns = excelFuelReportExpenseDetailsColumns()
  const config = {
    columns,
    filename: `Drivstoffrapport_${regNo}_${year}_${month}.xlsx`,
    sheetName: `Drivstoff_${regNo}_${year}_${month}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between ">
          <div className="flex flex-col md:items-center md:flex-row gap-2">
            <span className="text-xl font-medium text-primaryText">Drivstoffrapport</span>
            <span className=" hidden md:block text-lg text-secondaryText">/</span>
            <span className="text-lg text-secondaryText">
              {mapMonth(month)} {year}
            </span>
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={data} config={config} />
          </div>
        </div>
        <div className="hidden md:block">
          <ExcelExportButton data={data} config={config} />
        </div>
      </div>
      <FuelReportExpenseDetailsTable isLoading={isLoading} data={data} />
    </div>
  )
}

export default FuelReportExpenseDetails
